import { useEffect } from "react";
import { Config } from "../Config";

export function useDocumentTitle(title) {
  useEffect(() => {
    document.title = `${title} | ${Config?._AppName}`;
  }, [title]);
}
